import { render, staticRenderFns } from "./dualUseItem.vue?vue&type=template&id=2225c782&scoped=true"
import script from "./dualUseItem.vue?vue&type=script&lang=js"
export * from "./dualUseItem.vue?vue&type=script&lang=js"
import style0 from "./dualUseItem.vue?vue&type=style&index=0&id=2225c782&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2225c782",
  null
  
)

export default component.exports